import { Component, OnInit } from '@angular/core';
import { Po } from '../../po/po';
import { PoService } from '../../po/po.service';
import { Costcenter } from '../../costcenter/costcenter';
import { CostcenterService } from '../../costcenter/costcenter.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { PoListPipe } from '../../pipe/polist.pipe';

import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-pending-po',
  templateUrl: './pending-po.component.html',
  styleUrls: ['./pending-po.component.css']
})
export class PendingPoComponent implements OnInit {

  serchText:string= '';  
	 currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  purchase_order = new Po();  //Po is defined from abobe import po
  purchase_orders: Po[];
  costcenters: Costcenter[];
  public filter_purchase_orders:any = [];
  public Costcenter = "none"
  submitted = false;
	message: string;	

  poFilter: any = { ponumber: '' };
  totalrecord:number;
  constructor(private poService: PoService,
    private costcenterService: CostcenterService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
	  private auth: AuthService
    ) { }

  ngOnInit() {
     this.getPos();
     this.getCostCenters()
  }

  OpenCostcenter(){
    this.Costcenter='block'; 
   }

  
   closeCostcenter(){
    this.Costcenter='none'; 
  }
  

  getPos() {     

		 this.spinnerService.show();  
     if (this.auth.currentUserValue.userroleid == 7) {
      return this.poService.GetApprovalPOlevel1(this.auth.currentUserValue.userid)
      .subscribe(
       purchase_orders => {              
         this.purchase_orders = purchase_orders
         this.spinnerService.hide();
         this.totalrecord = this.purchase_orders.length;
         this.filter_purchase_orders = purchase_orders
         
        }
       );
     }else{
      return this.poService.GetApprovalPO(this.auth.currentUserValue.userid)
      .subscribe(
       purchase_orders => {              
         this.purchase_orders = purchase_orders
         this.spinnerService.hide();
         this.totalrecord = this.purchase_orders.length;
         this.filter_purchase_orders = purchase_orders
         
        }
       );
     }
	


 }

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}
getCostCenters() {
  return this.costcenterService.getCostcenterlist()
             .subscribe(
              costcenters => {
                this.costcenters = costcenters
                this.costcenters.filter(item => Object.assign(item, {isActive: true}));
				 this.costcenters = this.costcenters.filter(po => po.poapproverid == this.auth.currentUserValue.userid)
               }
              );
}

public getPolistByCostcenter(){
  var filter_purchase_order = this.filter_purchase_orders;
    this.purchase_orders = filter_purchase_order;
    for(var i= 0; i< this.costcenters.length; i++){
      if(!this.costcenters[i].isActive)
      {
        this.purchase_orders = this.purchase_orders.filter(po => po.costcenterid !== this.costcenters[i].costcenterid)
      }
    
  }
    this.totalrecord = this.purchase_orders.length;
  
}


resetAllFilters(){
  this.costcenters.filter(item => Object.assign(item, {isActive: true}));
  this.getPolistByCostcenter();
}
}


